import { FieldArray, useFormikContext } from 'formik';
import { useParams, Link } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Form, Input as AntInput, Button as AntButton, Select, Modal, Table, Tooltip, message, Upload } from 'antd';
import { useOrderBrandSave, useOrderBrandUpdate } from 'store/server/useOrder';
import DisliSayisiDetayModal from 'components/form/modals/DisliSayisiDetayModal';
import { Input as FormikInput } from 'components/form/input';
import { Input as UIInput } from 'components/ui/input';
import { Button as UIButton } from 'components/ui/button';
import { toast } from 'components/ui/use-toast';
import { RotateCcw, X } from 'lucide-react';
import { RxCross1 } from "react-icons/rx";
import { SelectReferanceCode10 } from 'components/form/compobox/select-referance-code10';
import { SelectReferanceCode10ZaraHome } from 'components/form/compobox/select-referance-code10zarahome';
import requests from 'service/api';
import ExtraHomeCardSizes from './BrandSıze/index';
import ExtraHomeCardSizesZaraHome from './BrandSıze/zaraHomeBrandSizes';
import { useAuth } from 'store/client/authStore'

const { Option } = Select;

export default function ExtraHomeCardInstructions({ currentTab,brannd }) {
  const { values, setFieldValue } = useFormikContext();
  const { mutate: saveOrder, isPending } = useOrderBrandSave();
  const { mutate: updateOrder, isPending: isPendingUpdate } = useOrderBrandUpdate();
  const { brand, orderNo, dept, subDept } = useParams();
  const [isDisliModalVisible, setIsDisliModalVisible] = useState(false)
  const [departmantIDD, setdepartmantIDD] = useState('')
  const [ifinch,setifinch] = useState(false)
  const brandId = brand.split('_')[0];
  const fieldArrayPushRef = useRef(null);
  const { user } = useAuth()

  // Default initialization for `extraHomeCardLabel`
  useEffect(() => {
    if ((!values.extraHomeCardLabel || values.extraHomeCardLabel.length === 0) && fieldArrayPushRef.current) {
      console.log(values.extraHomeCardLabel)
      fieldArrayPushRef.current({
        customerOrderNo: '',
        customerOrderDetail: '',
        colorCode: '',  
        sizes: []
      });
    }
  }, [values.extraHomeCardLabel]);
  const DrawerContent4 = () => {
    const [form4] = Form.useForm();
    const [isUploading, setIsUploading] = useState(false);
    const [uploadError, setUploadError] = useState(null);

    const handleFileUpload = async (values) => {
      const formData = new FormData();
      
      // Dosya kontrolü
      if (!values.file || values.file.length === 0) {
        message.error('Lütfen bir PDF dosyası seçin');
        return;
      }

      const file = values.file[0].originFileObj;
      const fileName = values.fileName;
      
      if (!fileName) {
        message.error('Lütfen bir dosya adı girin');
        return;
      }

      formData.append('file', file);
      formData.append('type', 'brand');
      formData.append('name', fileName);

      setIsUploading(true);
      setUploadError(null);

      try {
        const response = await requests.order.convertPdfToSvg(formData);
        
        if (response.status === 200) {
          message.success('PDF başarıyla SVG\'ye dönüştürüldü');
          form4.resetFields();
        }
      } catch (error) {
        console.error('Hata:', error);
        setUploadError('Dosya yüklenirken bir hata oluştu');
        message.error('Dosya yüklenirken bir hata oluştu');
      } finally {
        setIsUploading(false);
      }
    };

    return (
      <div>
        <Form
          form={form4}
          layout="vertical"
          onFinish={handleFileUpload}
        >
          <Form.Item
            label="Dosya Adı"
            name="fileName"
            rules={[{ required: true, message: 'Lütfen bir dosya adı girin' }]}
          >
            <AntInput 
              placeholder="Dosya adını girin"
              style={{ width: '100%' }}
            />
          </Form.Item>

          <Form.Item
            label="PDF Dosyası"
            name="file"
            rules={[{ required: true, message: 'Lütfen bir PDF dosyası seçin' }]}
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) {
                return e;
              }
              return e && e.fileList;
            }}
          >
            <Upload
              beforeUpload={(file) => {
                // Dosya tipini kontrol et
                const isPDF = file.type === 'application/pdf';
                if (!isPDF) {
                  message.error('Sadece PDF dosyaları yükleyebilirsiniz!');
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              accept=".pdf"
              maxCount={1}
              listType="text"
            >
              <AntButton>PDF Seç</AntButton>
            </Upload>
          </Form.Item>

          <Form.Item>
            <AntButton
              type="primary"
              htmlType="submit"
              loading={isUploading}
              style={{ width: '100%' }}
            >
              {isUploading ? 'Yükleniyor...' : 'PDF\'i Yükle ve SVG\'ye Dönüştür'}
            </AntButton>
          </Form.Item>

          {uploadError && (
            <div style={{ color: 'red', marginTop: '10px' }}>
              {uploadError}
            </div>
          )}
        </Form>
      </div>
    );
  };

  const handleSaveOrder = () => {
    if (!values.extraHomeCardLabel?.[0]?.colorCode) {
      toast.error("Renk Kodu Girilmek Zorunda");
      return;
    }
    if (!values.extraHomeCardLabel?.[0]?.referanceCode) {
      toast.error("Referans Kodu Girilmek zorunda");
      return;
    }
    
    const department = `${brand.split('_')[1]} / ${dept.split('_')[1]} / ${subDept}`;
    const filteredValues = (values.extraHomeCardLabel || []).map(label => {
      // fabric alanı varsa filtrele, yoksa olduğu gibi bırak
      if (label.fabric && Array.isArray(label.fabric)) {
        const filteredFabric = label.fabric.map(fabricItem => {
          const filteredMix = (fabricItem.mix || []).filter(mix => mix.percent > 0);
          return { ...fabricItem, mix: filteredMix };
        });
        return { ...label, fabric: filteredFabric };
      }
      return label;
    });

    const path = `${brand}/${dept}/${subDept}`;
    saveOrder({ ...values, extraHomeCardLabel: filteredValues, brand: brandId, department, path });
  };
  const handleDisliModalClose = () => {
    setIsDisliModalVisible(false)
  }

  const handleDisliModalOpen = () => {
    setIsDisliModalVisible(true)
  }
  const handleUpdateOrder = () => {
    const errors = []
    const filteredValuesxx = (values.extraHomeCardLabel || []).map((label) => {
      if(!label.colorCode || !label.referanceCode)
      {
        errors.push("Renk Kodu ve Referans Kodu Girilmek Zorunda")
      }
      return label
    })
   

    const filteredValues = values.washingLabel.map(label => {
      const filteredFabric = label.fabric.map(fabricItem => {
        const filteredMix = fabricItem.mix.filter(mix => mix.percent > 0);
        return { ...fabricItem, mix: filteredMix };
      });
      return { ...label, fabric: filteredFabric };
    });

    delete values.brandId;
    if(errors.length > 0) {
      toast.error(errors.join('\n'))
      return; // İşlemi durdurur
    }
    if(errors.length === 0)
    {
      updateOrder({ id: orderNo, body: { ...values, washingLabel: filteredValues, brand: brandId } });
    }
  };

  const ClearableSelect = ({ value, onChange, options, placeholder, form, name }) => {
    const handleClear = () => {
      form.setFieldsValue({ [name]: undefined });
      onChange(undefined);
    };

    return (
      <div style={{ position: "relative" }}>
        <Select
          showSearch
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ width: '100%' }}
          filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
          suffixIcon={<span style={{ display: 'none' }}></span>}
        >
          {options.map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
        {value && (
          <RxCross1
            onClick={handleClear}
            style={{
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "red",
            }}
          />
        )}
      </div>
    );
  };

  return (
    <FieldArray name="extraHomeCardLabel">
      {({ push, remove, form }) => {
        fieldArrayPushRef.current = push; // Reference the `push` function
        
        // FieldArray'in kendi değerlerini kullan
        const fieldArrayValues = form.values.extraHomeCardLabel || [];

        return (
          <div>
            {fieldArrayValues.map((_, idx) => (
              <div className="grid grid-cols-2 gap-5 pb-5 relative" key={idx}>
                <div className="col-span-2 grid grid-cols-2 gap-2 rounded border border-dashed p-2">
                  <UIInput
                    label="Müşteri Sipariş No"
                    value={fieldArrayValues[idx]?.customerOrderNo || ''}
                    onChange={(e) => {
                      setFieldValue(`extraHomeCardLabel[${idx}].customerOrderNo`, e.target.value);
                    }}
                  />
                  <FormikInput
                    label="Müşteri Sipariş Detayı"
                    name={`extraHomeCardLabel[${idx}].customerOrderDetail`}
                    autoComplete="off"
                  />
                  <FormikInput
                    label="Renk Kodu"
                    name={`extraHomeCardLabel[${idx}].colorCode`}
                    maxLength="3"
                    autoComplete="off"
                  />
          <DisliSayisiDetayModal
                  visible={isDisliModalVisible}
                  onCancel={handleDisliModalClose}
                  minWidth={'30%'} // modalType 4 ise minWidth 40%, aksi halde 30%
                  width={740}
                  title="Kemer Etiketi Referans Ekle"
                >
                  <DrawerContent4 />
                </DisliSayisiDetayModal>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                    <div style={{ width: '60%' }}>
                      {brannd === 'ZaraHome' ? (
                        <SelectReferanceCode10ZaraHome name={`extraHomeCardLabel[${idx}].referanceCode`} />
                      ) : (
                        <SelectReferanceCode10 name={`extraHomeCardLabel[${idx}].referanceCode`} />
                      )}
                    </div>
                    {user.companyName === "Şimşek Ege Etiket ve Matbaacılık\nLimited Şirketi" && 
                      user.tierType === "ADMIN" && (
  <div style={{ width: '20%', overflow:'hidden', marginRight:0,display:'none'}}>
    <UIButton
      type="button"
      variant="blue"
      onClick={handleDisliModalOpen}
      style={{width:'100%'}}
    >
      Referans Ekle
    </UIButton>
  </div>
)}
                    <div style={{ width: '20%' }}>

                    {(values.washingLabel?.some(label => label?.sizes?.length > 0) || 
    values.priceLabel?.some(label => label?.sizes?.length > 0) || 
    values.beltLabel?.some(label => label?.sizes?.length > 0)) && (
      <UIButton
  type="button"
  style={{backgroundColor:'#b0059c'}}
  onClick={() => {
    const availableLabels = [];
    
    // Her kaynak tipindeki her colorCode için ayrı seçenek oluştur
    if (values.washingLabel?.some(label => label?.sizes?.length > 0)) {
      const washingLabels = values.washingLabel.filter(label => label?.sizes?.length > 0);
      washingLabels.forEach((label, idx) => {
        availableLabels.push({
          type: 'washing',
          label: label,
          name: washingLabels.length > 1 ? `Yıkama Talimatı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Yıkama Talimatı',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.priceLabel?.some(label => label?.sizes?.length > 0)) {
      const priceLabels = values.priceLabel.filter(label => label?.sizes?.length > 0);
      priceLabels.forEach((label, idx) => {
        availableLabels.push({
          type: 'price',
          label: label,
          name: priceLabels.length > 1 ? `Fiyat Etiketi - ${label.colorCode || `Renk ${idx + 1}`}` : 'Fiyat Etiketi',
          colorCode: label.colorCode || ''
        });
      });
    }
    
    if (values.beltLabel?.some(label => label?.sizes?.length > 0)) {
      const beltLabels = values.beltLabel.filter(label => label?.sizes?.length > 0);
      beltLabels.forEach((label, idx) => {
        availableLabels.push({
          type: 'belt',
          label: label,
          name: beltLabels.length > 1 ? `Kemer Kartı - ${label.colorCode || `Renk ${idx + 1}`}` : 'Kemer Kartı',
          colorCode: label.colorCode || ''
        });
      });
    }

    if (availableLabels.length > 0) {
      let selectedIndex = null;

      // Tek seçenek varsa direkt kopyala
      if (availableLabels.length === 1) {
        const selectedItem = availableLabels[0];
        setFieldValue(`extraHomeCardLabel[${idx}]`, {
          ...(fieldArrayValues[idx] || {}),
          sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
          sizes: selectedItem.label.sizes.map(size => ({
            ...size,
            amount: size.amount || '',
            amountWithDefect: size.amountWithDefect || ''
          }))
        });
        message.success(`${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`);
      } else {
        // Birden fazla seçenek varsa modal göster
        Modal.confirm({
          title: 'Veri Kaynağını Seçin',
          content: (
            <Select 
              style={{ width: '100%' }} 
              placeholder="Kaynak seçin"
              onChange={(value) => { selectedIndex = value; }}
            >
              {availableLabels.map((item, itemIdx) => (
                <Select.Option key={itemIdx} value={itemIdx}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          ),
          onOk: () => {
            if (selectedIndex === null) {
              message.error('Lütfen bir kaynak seçin');
              return;
            }
            
            const selectedItem = availableLabels[selectedIndex];
            if (selectedItem && selectedItem.label) {
              setFieldValue(`extraHomeCardLabel[${idx}]`, {
                ...(fieldArrayValues[idx] || {}),
                sizeDefectivePercent: selectedItem.label.sizeDefectivePercent || '',
                sizes: selectedItem.label.sizes.map(size => ({
                  ...size,
                  amount: size.amount || '',
                  amountWithDefect: size.amountWithDefect || ''
                }))
              });
              message.success(`${selectedItem.name}${selectedItem.colorCode ? ' - ' + selectedItem.colorCode : ''} bedenleri kopyalandı`);
            }
          }
        });
      }
    } else {
      message.warning('Kopyalanacak veri bulunamadı');
    }
  }}
  className="w-full"
>
  Oto Doldur
</UIButton>
  )}
  </div>
                  </div>
                </div>
                <div className="col-span-2 grid grid-cols-2 gap-x-5">
                  {brannd === 'ZaraHome' ? (
                    <ExtraHomeCardSizesZaraHome idx={idx} brannd={brannd} setifinch={setifinch} setdepartmantIDD={setdepartmantIDD} ifinch={ifinch} />
                  ) : (
                    <ExtraHomeCardSizes idx={idx} brannd={brannd} />
                  )}
                  <div className="col-span-2">
                    {idx > 0 && (
                      <UIButton
                        variant="destructive"
                        onClick={() => remove(idx)}
                        className="absolute -right-40 top-0"
                      >
                        <X className="w-4 h-4 text-white" /> Renk Sil
                      </UIButton>
                    )}
                  </div>
                </div>
              </div>
            ))}

            <div className="flex items-center gap-x-5">
              {!orderNo && (
                <UIButton
                  type="submit"
                  variant="softgreen"
                  onClick={handleSaveOrder}
                  disabled={isPending}
                  className="w-full"
                >
                  {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Kaydet
                </UIButton>
              )}

              <UIButton
                type="button"
                onClick={orderNo ? handleUpdateOrder : handleSaveOrder}
                disabled={isPending || isPendingUpdate}
                className="w-full"
                variant={orderNo ? 'softgreen' : undefined}
              >
                {(isPending || isPendingUpdate) && <RotateCcw className="animate-spin mr-2" size={16} />} {orderNo ? 'Güncelle' : "Artwork'e Git"}
              </UIButton>

              {orderNo && (
                <Link
                  to={`/siparisler/artwork/${orderNo}?tab=${10}&zaratype=${brannd}`}
                  target="_blank"
                  className="w-full"
                >
                  <UIButton type="button" disabled={isPending} className="w-full">
                    {isPending && <RotateCcw className="animate-spin mr-2" size={16} />} Artwork'e Git
                  </UIButton>
                </Link>
              )}

              <UIButton
                type="button"
                variant="blue"
                onClick={() => {
                  push({
                    ...(fieldArrayValues[0] || {}),
                    colorCode: '',
                    customerOrderNo: '',
                    customerOrderDetail: '',
                    sizeDefectivePercent: '',
                    sizes: (fieldArrayValues[0]?.sizes || []).map(size => ({
                      ...size,
                      amount: '',
                      amountWithDefect: ''
                    }))
                  });
                }}
                className="w-full"
              >
                Renk Ekle
              </UIButton>
            </div>
          </div>
        );
      }}
    </FieldArray>
  );
}
